import { render, staticRenderFns } from "./MessagePremiumV2.vue?vue&type=template&id=e9ae8308&scoped=true&"
import script from "./MessagePremiumV2.vue?vue&type=script&lang=js&"
export * from "./MessagePremiumV2.vue?vue&type=script&lang=js&"
import style0 from "./MessagePremiumV2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MessagePremiumV2.vue?vue&type=style&index=1&id=e9ae8308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae8308",
  null
  
)

export default component.exports